import React, { useEffect } from "react";
import { Form, Input, DatePicker, Row, Col } from "antd";
import dayjs from "dayjs";

const CompanyOdsRefrigerantLog = ({ logs = [] }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (logs.length > 0) {
      const latest = logs[logs.length - 1];
      form.setFieldsValue({
        ...latest,
        date: latest.date ? dayjs(latest.date) : null,
      });
    }
  }, [logs, form]);

  return (
    <div className="white-container">
      <h3 className="section-title">ODS Refrigerant Log</h3>

      <Form layout="vertical" form={form} disabled>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Date" name="date">
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Supply of ODS (kgs)" name="supply_of_ods_kgs">
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Deliberate Discharge (kgs)"
              name="deliberate_discharge_kgs"
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Non-Deliberate Discharge (kgs)"
              name="non_deliberate_discharge_kgs"
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Discharge to Shore (kgs)"
              name="discharge_to_shore_kgs"
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Remarks" name="remarks">
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Signed by Electrical Engineer"
              name="sign_engineer"
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Signed by Chief Engineer"
              name="sign_chief_engineer"
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CompanyOdsRefrigerantLog;
